import apiClient from './apiClient';
import type { CercharData, CercharGeneral, CercharStylus } from '../types/rockCerchar';

export const getRockCercharData = async (workOrderDetailKey: string): Promise<CercharData> => {
  const r = await apiClient.get<CercharData>(`/workorderdetails/${workOrderDetailKey}/rockcerchar`);
  return r.data;
};

export const saveRockCercharData = async (
  workOrderDetailKey: string,
  general: CercharGeneral,
  styluses: CercharStylus[],
  confirmReset?: boolean,
): Promise<CercharData> => {
  const r = await apiClient.put(`/workorderdetails/${workOrderDetailKey}/rockcerchar`, {
    general,
    styluses,
    confirmReset,
  });
  return r.data;
};
